import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {

  token$ = this.authService.token$;
  footerText: string = '';

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.getClinicAndHospital();
  }

  getClinicAndHospital(): void {
    const data = this.token$.getValue();
    const clinicName = data?.clinicName ? `${data.clinicName}` : '';
    const hospitalName = data?.hospitalName ? ` ${data.hospitalName}` : '';
    this.footerText = `${clinicName}${hospitalName}`;
  }
}
